import { gsap } from "gsap";
import { Container, Sprite } from "pixi.js";

import { generateScaledSprite } from "../../../../abstracts/utils/GraphicUtils";

export class FsLowLocker extends Container {
    private lockerSprite: Sprite;

    constructor() {
        super();

        this.lockerSprite = generateScaledSprite(`Apocalypse/lowLockedFrame`);
        this.lockerSprite.anchor.set(0.5);
        this.lockerSprite.scale.set(0.6);
        this.lockerSprite.alpha = 0;
        this.addChild(this.lockerSprite);
    }

    public getAnimation(isRestore: boolean = false): gsap.core.Tween | gsap.core.Timeline {
        const tl = gsap.timeline({});

        const showFirstTape = gsap.to(this.lockerSprite, {
            alpha: 1,
            pixi: { scale: 0.5 },
            ease: `power4.in`,
            duration: isRestore ? 0.01 : 0.35,
        });

        tl.add(showFirstTape);

        return tl;
    }
}
